module.exports = __webpack_public_path__ + "img/CAL-IEC-voltage.1b571e36.png";